<script setup lang="ts">
import type { Room } from '~/shared/types/payload-types'

type FloorValue = 'souterrain' | 'ground' | 'first' | 'second' | 'third' | 'fourth' | 'garden'
type FloorGroup = { floor: FloorValue; rooms: Room[] }

const props = withDefaults(defineProps<{
  data: HomePage,
  floorGroups: FloorGroup[],
  isLoading?: boolean,
}>(), {
  isLoading: false,
})
</script>

<template>
  <div class="px-1">
    <div
      v-if="hasRichTextContent(data?.description)"
      class="mb-3 container-d"
    >
      <core-rich-text
        :content="data.description"
      />
    </div>

    <floorplan
      v-if="floorGroups.length"
      :floor-groups="floorGroups"
    />

    <!-- holds the page height while the rooms load, so the footer doesn't jump -->
    <div
      v-else-if="isLoading"
      class="min-h-[60vh] text-md"
      role="status"
      aria-live="polite"
    >
      {{ $t('labels.loading') }}
    </div>
  </div>
</template>
